import React from "react";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import SectionTitle from "../../components/Common/SectionTitle";
import BookCallForm from "../../components/BookCall/BookCallForm";
import { Helmet } from "react-helmet";
import OffWrap from "../../components/Layout/Header/OffWrap";
import Footer from "../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../components/Common/ScrollTop";
import Newsletter from "../../components/Common/Newsletter"

import bannerbg from "../../assets/img/breadcrumbs/inner13.jpg";
import contactHereImg from "../../assets/img/services/2.png";
import Header from "../../components/Layout/Header/Header";
import Logo from "../../assets/img/logo/dark-logo.png";
import footerLogo from "../../assets/img/logo/lite-logo.png";
import favIcon from "../../assets/img/fav.png";

const BookCallMain = () => {
  return (
    <React.Fragment>
      {/* SiteBreadcrumb */}
      <Header
        parentMenu="pages"
        secondParentMenu="others"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar="enable"
        TopBarClass="topbar-area home8-topbar"
        emailAddress="hello@syroltech.com"
        Location="Abuja, Nigeria"
      />
      <SiteBreadcrumb
        pageTitle="Schedule a Call"
        pageName="Schedule a Call"
        breadcrumbsImg={bannerbg}
      />
      {/* SiteBreadcrumb */}

      {/* Book Call Section Start */}
      <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
        <div className="container pb-66 md-pb-46">
          <div className="row y-middle">
            <div className="col-lg-6 md-mb-30">
              <div className="contact-widget">
                <SectionTitle
                  sectionClass="sec-title3 mb-36"
                  titleClass="title black-color mb-14"
                  title="Schedule a Call"
                  descClass="new-desc"
                  description="Schedule a call with our team. Fill out the form and we will get back to you as soon as possible."
                />
                {/* Book Call Form */}
                <BookCallForm submitBtnClass="btn-send" btnText="Schedule Now" />
                {/* Book Call Form */}
              </div>
            </div>
            <div className="col-lg-6 pl-60 md-pl-14 d-flex align-items-center justify-content-center">
              <div className="call-visual text-center">
                <img src={contactHereImg} alt="Book a Call" style={{maxWidth: '100%', height: 'auto'}} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Book Call Section End */}
      <Newsletter
        sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
        titleClass="title mb-0 white-color"
      />
      {/* Newsletter Section End */}

      {/* Footer */}
      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />
      {/* Footer */}

      {/* SearchModal */}
      <SearchModal />
      {/* SearchModal */}

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
    </React.Fragment>
  );
};

export default BookCallMain; 